import { render } from "./SearchAccount.vue?vue&type=template&id=6bab99ac&scoped=true"
import script from "./SearchAccount.vue?vue&type=script&lang=js"
export * from "./SearchAccount.vue?vue&type=script&lang=js"

import "./SearchAccount.vue?vue&type=style&index=0&id=6bab99ac&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bab99ac"]])

export default __exports__